import { Services } from './Services';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';

const ServicesWrapper = () => {
    return (
        <ServicesChartsDataProvider>
            <Services />
        </ServicesChartsDataProvider>
    );
};

export default ServicesWrapper;
